
require('./bootstrap')

import { createApp } from 'vue'
import Clock from './components/Clock'
import Auctioneer from './components/Auctioneer'
import Visitor from './components/Visitor'
import Edit from './components/Edit'
import { createPinia } from 'pinia'
import SvgVue from 'svg-vue3';
const pinia = createPinia()


const app = createApp({})

app.component('clock', Clock)
app.component('auctioneer', Auctioneer)
app.component('visitor', Visitor)
app.component('edit', Edit)
app.use(pinia)
app.use(SvgVue);
app.mount('#app')
